// eslint-disable-next-line @typescript-eslint/no-unused-vars
import client from './client';

const getAppVersion = () =>
  client.get<string>('/api/AppVersion').then((response) => response.data);

export default getAppVersion;
